import { FULL_ORIGIN } from '../config.js';
import { getCurrentLanguage } from '../translations.js';

const BRIDGE_ID = 'sfw-unrestricted-bridge';

const FALLBACK_COPY = {
  title: 'Mature content lives on Kissandra.red',
  body: 'This page stays filtered. Continue on Kissandra.red to open the same item there.',
  continue: 'Continue on Kissandra.red',
  stay: 'Stay here',
};

const escapeHtml = (value) => String(value)
  .replaceAll('&', '&amp;')
  .replaceAll('<', '&lt;')
  .replaceAll('>', '&gt;')
  .replaceAll('"', '&quot;');

const ensureBridgeCss = () => {
  if (document.querySelector('link[data-sfw-bridge-css]')) return;
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = '/css/modals/gender-preference-modal.css?v=sfw-bridge-pink';
  link.dataset.sfwBridgeCss = '1';
  document.head.appendChild(link);
};

const loadBridgeCopy = async () => {
  const language = getCurrentLanguage();
  try {
    const response = await fetch(`/translations/sfw-bridge-${language}.json`);
    if (response.ok) return { ...FALLBACK_COPY, ...await response.json() };
    if (language !== 'en') {
      const fallbackResponse = await fetch('/translations/sfw-bridge-en.json');
      if (fallbackResponse.ok) return { ...FALLBACK_COPY, ...await fallbackResponse.json() };
    }
  } catch (error) {
    console.error('Error loading unrestricted bridge translations:', error);
  }
  return FALLBACK_COPY;
};

export const unrestrictedContinueUrl = () => (
  `${FULL_ORIGIN}${window.location.pathname}${window.location.search}${window.location.hash}`
);

let isBridgeOpen = false;

export const showUnrestrictedBridge = async () => {
  if (isBridgeOpen || document.getElementById(BRIDGE_ID)) return;
  isBridgeOpen = true;
  ensureBridgeCss();
  const copy = await loadBridgeCopy();
  if (document.getElementById(BRIDGE_ID)) return;
  const continueUrl = escapeHtml(unrestrictedContinueUrl());
  const overlay = document.createElement('div');
  overlay.id = BRIDGE_ID;
  overlay.className = 'gender-preference-modal show';
  overlay.setAttribute('role', 'dialog');
  overlay.setAttribute('aria-modal', 'true');
  overlay.setAttribute('aria-labelledby', 'sfw-bridge-title');
  overlay.innerHTML = `
    <div class="gender-preference-modal-content">
      <div class="gender-preference-header">
        <p class="gender-preference-subtitle" id="sfw-bridge-title">${escapeHtml(copy.title)}</p>
      </div>
      <p class="preference-note">${escapeHtml(copy.body)}</p>
      <div class="age-confirm-container">
        <a class="age-confirm-btn age-confirm-btn-primary" href="${continueUrl}">${escapeHtml(copy.continue)}</a>
        <button type="button" class="age-confirm-btn age-confirm-btn-secondary" data-sfw-bridge-stay>${escapeHtml(copy.stay)}</button>
      </div>
    </div>`;
  const close = () => {
    isBridgeOpen = false;
    overlay.remove();
  };
  overlay.querySelector('[data-sfw-bridge-stay]')?.addEventListener('click', close);
  overlay.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') close();
  });
  document.body.appendChild(overlay);
  overlay.querySelector('[data-sfw-bridge-stay]')?.focus();
};
